module.exports = __webpack_public_path__ + "img/wf-finishing-position-19.1b16dbed.svg";